export default __webpack_public_path__ + "static/industryPerformance-284abcf213ce6988e17e6c39de4ece3f.png";